<template>
  <div
    :class="{
      'project-date-empty': orders.length === 0,
      empty: orders.length === 0,
    }"
  >
    <div class="project-date-header header">
      <h4>
        Zamówienia u dostawców ({{ orders.length }})
        <button
          class="btn"
          @click="toggleList = !toggleList"
          :class="{ active: !toggleList }"
        >
          <i class="fas fa-chevron-down"></i>
        </button>
      </h4>
    </div>
    <div v-if="toggleList" class="project-order-list">
      <div v-if="orders.length === 0">
        <i class="empty-state far fa-sticky-note"></i>
        <span class="empty-search">Brak zamówień</span>
      </div>
      <div v-else>
        <div class="project-order" v-for="(order, index) in orders" :key="index">
          <div class="project-order-content">
            <div class="project-order-title mb-0">
              <h5>{{ typeName(order.type) }}</h5>
              <span><small>Utworzono:</small> {{ order.created_at | date }}</span>
              <span><small>Adres dostawy:</small> {{ order.address }}</span>
            </div>
          </div>

          <b-dropdown
            no-caret
            right
            variant="light"
            class="btn-rounded"
            v-if="showOptions()"
          >
            <template v-slot:button-content>
              <i class="fas fa-ellipsis-v"></i>
            </template>
            <b-dropdown-item-button class="" @click="showModal(index)">
              Podgląd
            </b-dropdown-item-button>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item-button class="danger" @click="remove(index)">
              <i class="fas fa-trash-alt"></i> Usuń
            </b-dropdown-item-button>
          </b-dropdown>
           <b-button v-else @click="showModal(index)" size="sm" variant="light">Podgląd</b-button>

        </div>
      </div>
    </div>
    <SupplierOrdersModal :constructionid="constructionid" @onSubmit="addOrder"/>
    <SupplierOrderViewModal :selectedOrder="selectedOrder"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SupplierOrdersModal from "@/components/notes/SupplierOrdersModal";
import SupplierOrderViewModal from "@/components/notes/SupplierOrderViewModal";
import ordersService from "@/services/supplierorders.service";
import {formatDateOnly} from "@/services/helpers";

export default {
  name: "SupplierOrdersPortlet",
  components: { SupplierOrdersModal, SupplierOrderViewModal },
  props: {
    orders: { type: Array },
    constructionid: { type: Number },
  },
  data() {
    return {
      selected: {},
      selectedOrder: {},
      toggleList: true,
    };
  },
  filters: {
    date(value) {
      return formatDateOnly(value, "YYYY-MM-DD");
    }
  },
  computed: {
    ...mapGetters("user", ["getRole"])
  },
  methods: {
    showModal(orderIndex) {
      let order = this.orders[orderIndex];
        this.selectedOrder = order;
        this.$bvModal.show("supplierOrderView-modal");
    },
    showOptions() {
      if (
        this.getRole !== "subcontractor" &&
        this.getRole !== "employee_simple"
      )
        return true;
      return false;
    },
    remove(orderIndex) {
      let order = this.orders[orderIndex],
        h = this.$createElement;
      this.$bvModal
        .msgBoxConfirm(
          [
            h("p", [
              "Czy na pewno chcesz usunąć zamówienie?",
            ]),
          ],
          {
            title: "Potwierdź usunięcie zamówienia",
            okVariant: "danger",
            okTitle: "TAK",
            cancelTitle: "NIE",
          }
        )
        .then((result) => {
          if (result === true) {
            this.$Progress.start();
            ordersService.delete(this.constructionid, order.id).then(() => {
              this.orders.splice(orderIndex, 1);
            });
          }
        });
    },
    typeName(type) {
      switch (type) {
        case 'door':
          return "Drzwi"

        default:
          return "Nieznany rodzaj"
      }
    },
    clean() {
      this.selected = {};
    },
    addOrder(order) {
      this.orders.push(order);
    }
  },
};
</script>
